import type { SugarmateError } from "@tandemdiabetes/sugarmate-api-react-client"
import { Toast } from "@tandemdiabetes/sugarmate-react-components"
import { useMemo } from "react"
import { usePolyglot } from "src/contexts"

interface Props {
  id: string;
  status?: SugarmateError["status"];
  code?: SugarmateError["code"];
}

const polyglotPrefix = "toasts.update_password_error."

export function UpdatePasswordErrorToast(props: Props) {
  const {
    id,
    code = null,
  } = props

  const polyglot = usePolyglot()
  const body = useMemo(
    () => {
      switch (code) {
        case 1012: // password doesn't meet requirements
          return polyglot.t("error_messaging.password_invalid")
        case 1022: // current password is incorrect
          return polyglot.t(`${polyglotPrefix}current_password_body`)
        default:
          return polyglot.t("error_messaging.generic_error")
      }
    },
    [
      code,
      polyglot,
    ],
  )

  return (
    <Toast
      stylePreset="error"
      body={body}
      id={id}
    />
  )
}
